import { render, staticRenderFns } from "./NavBarProject.vue?vue&type=template&id=f525d16c&"
import script from "./NavBarProject.vue?vue&type=script&lang=js&"
export * from "./NavBarProject.vue?vue&type=script&lang=js&"
import style0 from "./NavBarProject.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports